import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { render, renderHook, RenderHookOptions, RenderOptions } from '@testing-library/react';

const queryClient = new QueryClient();

function Providers({ children }: { children: React.ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}

const customRender = (ui: React.ReactElement, options?: RenderOptions) =>
  render(ui, {
    wrapper: Providers,
    ...options,
  });

const customRenderHook = <Props, Result>(fn: (initialProps: Props) => Result, options?: RenderHookOptions<Props>) =>
  renderHook(fn, {
    wrapper: Providers,
    ...options,
  });

export * from '@testing-library/react';
export { customRender as render, customRenderHook as renderHook, queryClient };
